export default "__VITE_ASSET__RBqetJyG__"